import React from "react";
import A2PortfolioTechStack from "../Components/A2PortfolioTechStack";

export default function EventStaffingTechStack() {
  const slides = [
    {
      title: "Frontend",
      logos: ["nextjs.svg", "typescript.svg", "scss.svg", "antd.svg"],
    },
    {
      title: "Backend",
      logos: ["backendlogo3.png", "Express.png", "prisma.svg"],
    },
    {
      title: "Database",
      logos: ["database4.png"],
    },
  ];

  return (
    <section className="es-techstack-section">
      <A2PortfolioTechStack
        slides={slides}
        headingColor="clr-fff"
        Color="es-ts-border"
        strokeTextColor="es-portfolio-stroke-text"
      />
    </section>
  );
}
